import { createContext } from "react";
import { AppInfo } from "./AppInfo";

export const AppInfoContext = createContext<AppInfo>({} as AppInfo);
